import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://leons-mac-mini.tailb90d8b.ts.net';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzgyMjI2Nzk5LCJleHAiOjE5Mzk5MDY3OTl9.PH_Hd33xmZGh68py41Bp7642DHNlVDWYpmv2HLgVJ_Q';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
